<script setup>
import TvP08ButtonComp from '../TvP08Button/TvP08ButtonComp.vue';

defineProps({
  popupTitle: { type: String, default: '' },
  popupMessage: { type: String, default: '' },
  hasSecondaryButton: { type: Boolean, default: false },
  focusedButtonIndex: { type: Number, default: 0 },
  primaryButtonCopy: { type: String, default: '' },
  isPrimaryWithProgress: { type: Boolean, default: false },
  primaryProgressSecondsRemaining: { type: Number, default: 0 },
  primaryProgressTotalSeconds: { type: Number, default: 0 },
  secondaryButtonCopy: { type: String, default: '' },
  isSecondaryWithProgress: { type: Boolean, default: false },
  secondaryProgressSecondsRemaining: { type: Number, default: 0 },
  secondaryProgressTotalSeconds: { type: Number, default: 0 },
});

// // TvP08Popup setup functions

// // TvP08Popup handler functions

// // TvP08Popup watchers
</script>

<template>
  <div class="tvp-08-popup">
    <div v-if="popupTitle" class="tvp-08-popup__title">{{ popupTitle }}</div>
    <div v-if="popupMessage" class="tvp-08-popup__message">{{ popupMessage }}</div>

    <div v-if="$slots.body" class="tvp-08-popup__body">
      <slot name="body" />
    </div>

    <div class="tvp-08-popup__buttons">
      <TvP08ButtonComp
        class="tvp-08-popup__button"
        :button-copy="primaryButtonCopy"
        :is-focused="focusedButtonIndex === 0"
        :is-with-progress="isPrimaryWithProgress"
        :progress-seconds-remaining="primaryProgressSecondsRemaining"
        :progress-total-seconds="primaryProgressTotalSeconds"
      />
      <TvP08ButtonComp
        v-if="hasSecondaryButton"
        class="tvp-08-popup__button"
        :button-copy="secondaryButtonCopy"
        :is-focused="focusedButtonIndex === 1"
        :is-with-progress="isSecondaryWithProgress"
        :progress-seconds-remaining="secondaryProgressSecondsRemaining"
        :progress-total-seconds="secondaryProgressTotalSeconds"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use './tvp08popup.scss';
</style>
